//
// Copyright (c) 2025 Comcast
//

import PropTypes from 'prop-types'
import Sidebar from './Index'

const WIDTH = 296

const LeftSidebar = ({
  show, headerComponent, title, dataTest, children,
}) => {
  return (
    <Sidebar
      leftSide
      noCloseButton
      show={show}
      headerComponent={headerComponent}
      title={title}
      dataTest={dataTest}
      width={WIDTH}
    >
      {children}
    </Sidebar>
  )
}

LeftSidebar.propTypes = {
  show: PropTypes.bool,
  headerComponent: PropTypes.node,
  title: PropTypes.string,
  dataTest: PropTypes.string,
  children: PropTypes.node,
}

export default LeftSidebar
